import judge from './view';

export default [
  {
    path: '/',
    component: judge('/redirect'),
  },
  {
    path: 'login', // 로그인
    component: judge('/login'),
  },
  {
    path: 'join', // 인증심사원 가입
    component: judge('/join'),
  },
  {
    path: 'userInfo', // 인증심사원 개인정보관리
    component: judge('/userInfo'),
  },
  {
    path: 'joinComplete', // 인증심사원 가입 완료
    component: judge('/joinComplete'),
  },
  {
    path: 'status', // 심사대상현황
    component: judge('/status'),
  },
  {
    path: 'status/:sq', // 심사대상현황 내역
    component: judge('/statusDetail'),
  },
  {
    path: 'factoryAppraisal/:sq', // 공장심사평가
    component: judge('/factoryAppraisal'),
  },
  {
    path: 'factoryStatus/:sq', // 공장현황작성
    component: judge('/factoryStatus'),
  },

  {
    path: 'factoryEval/:sq', // 공장심사보고서
    component: judge('/factoryEval'),
  },
  {
    path: 'unsuitable/:sq', // 부적합보고서
    component: judge('/unsuitable'),
  },
  {
    path: 'testRequestStatus/:sq', // 시료채취내역 및 제품 품질시험 의뢰현황
    component: judge('/testRequestStatus'),
  },
  {
    path: 'improve', // 부적합개선조치관리
    component: judge('/improve'),
  },
  {
    path: 'improve/:sq', // 부적합개선조치관리 > 상세보기
    component: judge('/improveDetail'),
  },
  {
    path: 'improveAction/:sq', // 부적합개선조치보고서
    component: judge('/improveAction'),
  },
  {
    path: 'checkEval/:sq', // 확인심사보고서
    component: judge('/checkEval'),
  },
  { path: '*', redirect: '/404' },
];



// WEBPACK FOOTER //
// ./src/router/judge/index.js